import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingPhpConfigAction from '../actions/hosting-php-configs.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {LoadPhpConfigs} from "../actions";
import {HostingPhpConfigMapper} from "../../websites/website/hosting/info/hosting-php-config-mapper";

@Injectable()
export class HostingPhpConfigsEffect {

  loadPhpConfigs = createEffect(() => this._actions$.pipe(
    ofType(hostingPhpConfigAction.LOAD_PHP_CONFIGS),
    mergeMap((action: LoadPhpConfigs) => {
      return this._hostingService.hostingPhpConfigs(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingPhpConfigAction.LoadPhpConfigsSuccess({
                websiteId: action.payload,
                entities: HostingPhpConfigMapper.map(response.data)
              });
            }
            return new hostingPhpConfigAction.LoadPhpConfigsFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
